<template>
  <div class="page-wrapper">
    <div class="page-inner">
      <layout-navbar />

      <div class="page-content-wrapper">
        <layout-header />

        <layout-body />

        <layout-footer />
      </div>
    </div>
  </div>
</template>

<script>
import LayoutBody from '@/components/appLayout/Body.vue';
import LayoutFooter from '@/components/appLayout/Footer.vue';
import LayoutHeader from '@/components/appLayout/Header.vue';
import LayoutNavbar from '@/components/appLayout/Navbar.vue';

// @vuese
// Layout aplikacji
// @group Layouts
export default {
  components: {
    LayoutHeader,
    LayoutNavbar,
    LayoutBody,
    LayoutFooter
  }
};
</script>
